<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px rgb(12, 92, 200);">在站科研用户</span></p>
          <table style="margin-left : 15px; margin-top : 40px; align-content: center; border: solid 1px #2ba8e2; font-size: 16px; text-align: center;  ">
            <tr style="background-color: rgb(12, 92, 200); color: white; height: 50px; ">
              <th style="border: solid 1px lightgrey;width:50px; vertical-align: middle; font-weight: bold">NO.</th>
              <th style="border: solid 1px lightgrey;width: 420px; vertical-align: middle; font-weight: bold">用户工作站名称</th>
              <th style="border: solid 1px lightgrey;width: 120px; vertical-align: middle; font-weight: bold">负责人</th>
              <th style="border: solid 1px lightgrey;width: 550px; vertical-align: middle; font-weight: bold">共建单位</th>
            </tr>
            <tr v-for="(userStationList,index) in userStationList" style=" align: center; height: 50px;"  class="list-style">
              <td style="border: solid 1px lightgrey; vertical-align: middle; font-weight: bold"  class="item-style">	{{ index+1 }}	</td>
              <td style="border: solid 1px lightgrey; vertical-align: middle; font-weight: bold"  class="item-style"><a :href="'/detail?type=user_stations&id='+userStationList.userStationsId">	{{ userStationList.title }}	</a></td>
              <td style="border: solid 1px lightgrey; vertical-align: middle; font-weight: bold"  class="item-style">	{{ userStationList.principal }}</td>
              <td style="border: solid 1px lightgrey; vertical-align: middle; font-weight: bold"  class="item-style">	{{ userStationList.partner }}	</td>
            </tr>
          </table>
          <p>&nbsp;</p>

        </div>
      </div>
    </div>
    <v-contact></v-contact>

  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/";
import $ from "jquery";
export default {
  data () {
    return {
      userStationList: [],
      richText: '',
    };
  },
  mounted () {

    // 用户工作站列表
    //为了在内部函数能使用外部函数的this对象，要给它赋值了一个名叫self的变量。
    var self = this;
    var allUserStations = '';
    $.ajax({
      url:  Header.IP_URL + '/user_stations/simpleList',
      type: 'get',
      // data: {},
      dataType: 'json'
    }).then(function (res) {
      console.log(res);
      //把从json获取的数据赋值给数组
      self.userStationList = res.data;

    }).fail(function () {
      console.log('失败');
    });

  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss" scoped>
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  margin-top: 0px;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
  }
  line-height: 32px;
}


/* 奇数行的样式 */
.list-style:nth-child(odd)>.item-style {
  background-color: white;
}

/* 偶数行的样式 */
.list-style:nth-child(even)>.item-style {
  background-color: white;
}

</style>



// WEBPACK FOOTER //
// src/pages/kyuser3/index.vue